import { alpha, Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import IconMi from 'components/common/icon/IconMi';
import useBundleTranslation from 'i18n';
import styles from 'components/common/page-menu/PageMenu.styles';
import RouteLink from 'components/common/route-link/RouteLink';
import { useLocation } from 'react-router-dom';
import { RETURN_TO_PARAM, safeReturnTo } from './returnTo';

export default function PanelBackButton({
    settings,
}: {
    settings?: {
        href: string;
    };
}) {
    const { t } = useBundleTranslation();
    const location = useLocation();
    // An editor opened from another editor (e.g. the KG Editor) returns to where the user came from.
    const href = safeReturnTo(new URLSearchParams(location.search).get(RETURN_TO_PARAM)) ?? settings?.href;
    if (!href) return null;
    return (
        <>
            <Tabs value={false} onChange={() => {}} sx={{ ...styles.tabs, mb: 0, flexShrink: 0, flexGrow: 0 }}>
                <Tab
                    icon={<IconMi icon={'chevron-left'} sx={styles.tabItem} />}
                    iconPosition="start"
                    component={RouteLink}
                    to={href}
                    data-test="panel_back_button"
                    label={<Box sx={styles.labelHolder}>{t('back')}</Box>}
                />
            </Tabs>
            <Box
                sx={{
                    width: '1px',
                    height: '16px',
                    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                    flexShrink: 0,
                }}
            />
        </>
    );
}
